var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-form"},[(_vm.isLoginState)?_c('UserLogin',{attrs:{"callback":_vm.changeState}}):_c('UserReg',{attrs:{"callback":_vm.changeState}})],1),_c('div',{staticClass:"login-background-image"},[_c('img',{attrs:{"src":require('@/assets/管理会议.png'),"alt":"背景图片"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }